import { AuthChannel } from "./types"

export function dispatchLoggedInEvent() {
  localStorage.setItem("is-authenticated", "true")
  const authChannel = new BroadcastChannel(AuthChannel.Name)
  authChannel.postMessage(AuthChannel.LoginEvent)
  authChannel.close()
}

export function dispatchLoggedOutEvent() {
  localStorage.removeItem("is-authenticated")

  const authChannel = new BroadcastChannel(AuthChannel.Name)
  authChannel.postMessage(AuthChannel.LogoutEvent)
  authChannel.close()
}
